import {
  Button,
  Checkbox,
  Drawer,
  Input,
  Label,
  Loading,
  Textarea,
  Title,
} from "@components";

import { OnboardingAPI } from "providers/OnboardingAPI";
import { useEffect, useMemo, useRef, useState } from "react";
import { useNavigate } from "react-router";
import { ForEach, If } from "shared/components/control-statements";
import {
  InfoCircle,
  InfoCircleGreen,
  InfoCircleGrey,
  Interrogation,
} from "shared/components/Icons";
import { InputSearch } from "shared/components/InputSearch";
import Toggle2 from "shared/components/Toggle2";
import { useDragScroll } from "shared/hooks/useDragScroll";
import { CNPJ } from "shared/tools/CNPJ";
import { EnvironmentStorage } from "shared/tools/EnvironmentStorage";
import styles from "styles/onboarding.module.scss";
import { v4 as uuid } from "uuid";

import classNames from "classnames/bind";
import { BrazilStates } from "shared/utils/BrazilStates";
import L from "leaflet";
import { MapContainer, TileLayer, Marker } from "react-leaflet";
import "leaflet/dist/leaflet.css";
import SearchAddressesLocation from "shared/containers/SearchAddressLocation";
import { Phone } from "shared/utils/Phone";
import { EnvironmentsAPI } from "providers/EnvironmentsAPI";
const css = classNames.bind(styles);

function isUUID(value) {
  const uuidRegex =
    /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;
  return uuidRegex.test(value);
}

const DraggableMarker = ({ position, readOnly, onChangePosition }) => {
  const icon = new L.Icon({
    iconUrl: require("../../assets/location.png"),
    iconAnchor: [25, 50],
  });

  const [latLng, setPosition] = useState(position);

  const markerRef = useRef(null);
  const eventHandlers = useMemo(
    () => ({
      dragend() {
        const marker = markerRef.current;
        if (marker != null) {
          setPosition(marker.getLatLng());
          onChangePosition && onChangePosition(marker.getLatLng());
        }
      },
    }),
    []
  );

  return (
    <Marker
      draggable={!readOnly}
      eventHandlers={eventHandlers}
      position={latLng}
      ref={markerRef}
      icon={icon}
    />
  );
};

export default function OnboardingUnits() {
  const environment = EnvironmentStorage.getEnvironment();

  const [search, setSearch] = useState("");
  const [units, setUnits] = useState([]);
  const [originalUnits, setOriginalUnits] = useState([]);
  const [hideCompletedUnits, setHideCompletedUnits] = useState(false);
  const [openDescription, setOpenDescription] = useState(false);
  const [openCopyDescription, setOpenCopyDescription] = useState(false);
  const [openCopyCnpj, setOpenCopyCnpj] = useState(false);
  const [openCopyPhone, setOpenCopyPhone] = useState(false);
  const [openCopyEmail, setOpenCopyEmail] = useState(false);
  const [openCopyAddress, setOpenCopyAddress] = useState(false);
  const [openCopyIfood, setOpenCopyIfood] = useState(false);
  const [openCopyWhatsapp, setOpenCopyWhatsapp] = useState(false);
  const [selectedUnit, setSelectedUnit] = useState(null);
  const [selectedItems, setSelectedItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const [openSuccess, setOpenSuccess] = useState(false);
  const [brands, setBrands] = useState([]);
  const [selectedBrand, setSelectedBrand] = useState(null);
  const [openAddMultiple, setOpenAddMultiple] = useState(false);
  const [unitsToAdd, setUnitsToAdd] = useState("");
  const [addressOptions, setAddressOptions] = useState(null);
  const [openSelectAddress, setOpenSelectAddress] = useState(false);
  const [openError, setOpenError] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [title, setTitle] = useState("");

  const navigate = useNavigate();

  const { scrollRef, onMouseDown, wasDragging } = useDragScroll();

  const emptyUnit = {
    id: uuid(),
    active: true,
    name: "",
    cnpj: "",
    url: "",
    brand_id: selectedBrand,
    email: "",
    phone: "",
    whatsapp: "",
    address: "",
    ifood_merchant_id: "",
  };

  const validLinkRegex = /^(https?:\/\/)?([\w-]+\.)+(com|com\.br)(\/.*)?$/i;

  function getCompletionPercentage() {
    if (!Array.isArray(units) || units.length === 0) return 0;

    const requiredFields = [
      "name",
      "cnpj",
      "address",
    ];
    const totalFields = units.length * requiredFields.length;

    let filledCount = 0;

    for (const item of units) {
      for (const field of requiredFields) {
        const value = item[field];
        if (!value) continue;

        filledCount++;
      }
    }

    const percentage = (filledCount / totalFields) * 100;
    return Number(percentage.toFixed(0));
  }

  const filteredUnits = units.filter((unit) => {
    return unit.name.toLowerCase().includes(search.toLowerCase());
  });

  function getIncompleteObjects(data) {
    if (!Array.isArray(data)) return [];

    const requiredFields = [
      "name",
      "cnpj",
      "email",
      "phone",
      "whatsapp",
      "address",
      "ifood_merchant_id",
    ];

    return data.filter((item) => {
      for (const field of requiredFields) {
        const value = item[field];
        if (!value) return true;
      }
      return false;
    });
  }

  const finalUnits = hideCompletedUnits
    ? getIncompleteObjects(filteredUnits)
    : filteredUnits;

  function updateObjectsByIds(data, selectedItems, field, newValue) {
    if (!Array.isArray(data) || !Array.isArray(selectedItems) || !field)
      return data;

    return data.map((item) =>
      selectedItems.includes(item.id) ? { ...item, [field]: newValue } : item
    );
  }

  const Items = () => {
    const [search, setSearch] = useState("");

    const filteredUnits = units.filter((unit) => {
      const brandName = brands.find((b) => b.id === unit.brand_id)?.name || "";
      const searchLower = search.toLowerCase();
      return (
        unit.name.toLowerCase().includes(searchLower) ||
        brandName.toLowerCase().includes(searchLower)
      );
    });

    return (
      <div className={styles.itemsContainer}>
        <InputSearch
          placeholder="Buscar por..."
          onChange={(e) => setSearch(e.target.value)}
          design="two"
          className="mt-20"
        />

        <div className={styles.header}>
          <p>{selectedItems.length} selecionado(s)</p>
          <Checkbox
            checked={selectedItems.length === units.length}
            onChange={() => {
              const filtered = units.filter((b) => b.id !== selectedUnit?.id);

              if (selectedItems.length === filtered.length)
                setSelectedItems([]);
              else setSelectedItems(filtered.map((b) => b.id));
            }}
          />
        </div>
        <ForEach
          items={filteredUnits.filter((b) => b.id !== selectedUnit?.id)}
          render={(item) => {
            const brandName = brands.find((b) => b.id === item.brand_id)?.name;

            return (
              <div
                className={styles.brand}
                onClick={() => {
                  if (selectedItems.includes(item.id))
                    setSelectedItems((prev) =>
                      prev.filter((b) => b !== item.id)
                    );
                  else setSelectedItems((prev) => [...prev, item.id]);
                }}
              >
                <Checkbox checked={selectedItems.includes(item.id)} />
                <p className={styles.brandName}>
                  {brandName} - {item.name}
                </p>
              </div>
            );
          }}
        />
      </div>
    );
  };

  const handleUnitChange = (unitId, field, value) => {
    setUnits((prevUnits) => {
      const newUnits = [...prevUnits];
      const index = newUnits.findIndex((b) => b.id === unitId);
      if (index !== -1) {
        newUnits[index][field] = value;
      }
      return newUnits;
    });
  };

  const getUnits = async () => {
    const response = (await OnboardingAPI.getUnits()) || [];
    setUnits(response || []);
    setOriginalUnits(response || []);
    setLoading(false);
  };

  const save = async () => {
    setLoading(true);

    const unitsWithoutId = units.map((b) => {
      if (isUUID(b.id)) delete b.id;
      return b;
    });

    const response = await OnboardingAPI.putUnits(unitsWithoutId);

    if (response.getErrors({}).length > 0) {
      setOpenError(true);
      setErrorMessage(response.getErrors({})[0]);
    } else {
      setOpenSuccess(true);
      getUnits();
    }

    setLoading(false);
  };

  const getBrands = async () => {
    const response = await OnboardingAPI.getBrands();
    if (response) {
      setSelectedBrand(response[0]?.id);
      setBrands(response);
    }
  };

  useEffect(() => {
    getBrands();
    getUnits();
  }, []);

  const generateAddressString = (addr) => {
    if (!addr?.address) return "";

    let stringAddress = `${addr.address}`;

    if (addr.number) stringAddress += `, ${addr.number}`;
    if (addr.complement) stringAddress += ` (${addr.complement})`;
    if (addr.observation) stringAddress += ` ${addr.observation}`;

    const shortNameState = BrazilStates.getShortNameByName(addr.state);

    stringAddress += ` - ${addr.region} - ${addr.city}/${shortNameState}`;
    return stringAddress;
  };

  const getHolding = async () => {
    const environmentId = await EnvironmentStorage.getEnvironmentHoldingId();

    const holdingResponse = await EnvironmentsAPI.getById(environmentId);
    const holding = holdingResponse.getData({});
    if (holding.name) setTitle(holding.name || environment?.brand?.name);
  };

  useEffect(() => {
    getHolding();
  }, []);

  const removeUnit = async (unitId) => {
    setUnits((prevUnits) => prevUnits.filter((b) => b.id !== unitId));
  };

  return (
    <div className={styles.onboardingComponent}>
      <If cond={loading}>
        <Loading onboarding style={{ top: 95 }} />
      </If>
      <div className={styles.onboardingHeader}>
        <div className={styles.content}>
          <Title title="Unidades" backTo={{ name: title, url: "/implantacao" }}>
            <div className="d-flex align-center gap-10">
              <If cond={units.length}>
                <InputSearch
                  placeholder="Buscar por..."
                  onChange={(e) => setSearch(e.target.value)}
                  design="four"
                />
                <Button
                  className="gap-10"
                  onClick={() => setHideCompletedUnits(!hideCompletedUnits)}
                >
                  <If cond={hideCompletedUnits}>
                    <i className="fal fa-eye" />
                    <span>Ocultar concluídos</span>
                  </If>
                  <If cond={!hideCompletedUnits}>
                    <i className="fal fa-eye-slash" />
                    <span>Mostrar concluídos</span>
                  </If>
                </Button>
              </If>

              {/* <Interrogation /> */}
            </div>
            <div className={styles.divider} />
            <div className={styles.completeness}>
              <div
                className={styles.total}
                style={{ "--percent": getCompletionPercentage() }}
              >
                <span>{getCompletionPercentage()}%</span>
              </div>
            </div>
          </Title>
        </div>
      </div>

      <div className={styles.onboardingContainer}>
        <If cond={brands.length > 1}>
          <div className={styles.brands}>
            <ForEach
              items={brands}
              render={(item) => {
                return (
                  <div
                    className={css({
                      brand: true,
                      selected: selectedBrand === item.id,
                    })}
                    onClick={() => setSelectedBrand(item.id)}
                  >
                    <p className={styles.name}>{item.name}</p>
                  </div>
                );
              }}
            />
          </div>
        </If>

        <div
          onMouseDown={onMouseDown}
          ref={scrollRef}
          className={styles.table}
          style={{ maxHeight: "calc(100dvh - 220px)" }}
        >
          <table>
            <thead>
              <tr>
                <th
                  style={{
                    minWidth: 110,
                    position: "sticky",
                    left: 0,
                    zIndex: 200,
                    paddingLeft: 45,
                  }}
                >
                  STATUS
                </th>
                <th
                  style={{
                    position: "sticky",
                    left: 110,
                    zIndex: 200,
                  }}
                >
                  NOME DA UNIDADE
                </th>
                <th>CNPJ</th>
                <th>E-MAIL</th>
                <th>TELEFONE</th>
                <th>WHATSAPP</th>
                <th>ENDEREÇO</th>
                <th>MERCHANT ID (IFOOD)</th>
                <th>EXCLUIR</th>
              </tr>
            </thead>
            <tbody>
              <ForEach
                items={finalUnits}
                render={(unit) => {
                  if (unit.brand_id !== selectedBrand) return null;

                  return (
                    <tr key={unit.id}>
                      <td
                        style={{
                          width: 110,
                          position: "sticky",
                          left: 0,
                          zIndex: 200,
                        }}
                      >
                        <div
                          className="d-flex justify-center"
                          style={{ paddingLeft: 22.5 }}
                        >
                          <Toggle2
                            checked={unit.active}
                            onChange={() => {
                              handleUnitChange(unit.id, "active", !unit.active);
                            }}
                          />
                        </div>
                      </td>
                      <td
                        style={{
                          minWidth: 300,
                          width: 300,
                          position: "sticky",
                          left: 110,
                          zIndex: 200,
                        }}
                      >
                        <Input
                          design="mini"
                          className="w-100"
                          value={unit.name}
                          onChange={(e) =>
                            handleUnitChange(unit.id, "name", e.target.value)
                          }
                          filled={!!unit.name}
                        />
                      </td>
                      <td style={{ minWidth: 300, width: 300 }}>
                        <div className="d-flex align-center gap-10">
                          <Input
                            design="mini"
                            className="w-100"
                            value={unit.cnpj}
                            onChange={(e) => {
                              const cnpj = CNPJ.mask(e.target.value);
                              handleUnitChange(unit.id, "cnpj", cnpj);
                            }}
                            filled={!!unit.cnpj}
                          />
                          <Button
                            design="default-icon-mini-2"
                            onClick={() => {
                              setOpenCopyCnpj(true);
                              setSelectedUnit(unit);
                            }}
                            disabled={!unit.cnpj}
                          >
                            <i className="fal fa-layer-group" />
                          </Button>
                        </div>
                      </td>
                      <td style={{ minWidth: 300 }}>
                        <div className="d-flex align-center gap-10">
                          <Input
                            design="mini"
                            className="w-100"
                            value={unit.email}
                            onChange={(e) =>
                              handleUnitChange(unit.id, "email", e.target.value)
                            }
                          />
                          <Button
                            design="default-icon-mini-2"
                            onClick={() => {
                              setOpenCopyEmail(true);
                              setSelectedUnit(unit);
                            }}
                            disabled={!unit.email}
                          >
                            <i className="fal fa-layer-group" />
                          </Button>
                        </div>
                      </td>
                      <td style={{ minWidth: 300 }}>
                        <div className="d-flex align-center gap-10">
                          <Input
                            design="mini"
                            className="w-100"
                            value={unit.phone}
                            onChange={(e) => {
                              const value = Phone.mask(e.target.value);
                              handleUnitChange(unit.id, "phone", value);
                            }}
                          />
                          <Button
                            design="default-icon-mini-2"
                            onClick={() => {
                              setOpenCopyPhone(true);
                              setSelectedUnit(unit);
                            }}
                            disabled={!unit.phone}
                          >
                            <i className="fal fa-layer-group" />
                          </Button>
                        </div>
                      </td>
                      <td style={{ minWidth: 300 }}>
                        <div className="d-flex align-center gap-10">
                          <Input
                            design="mini"
                            className="w-100"
                            value={unit.whatsapp}
                            onChange={(e) => {
                              const value = Phone.mask(e.target.value);
                              handleUnitChange(unit.id, "whatsapp", value);
                            }}
                          />
                          <Button
                            design="default-icon-mini-2"
                            onClick={() => {
                              setOpenCopyWhatsapp(true);
                              setSelectedUnit(unit);
                            }}
                            disabled={!unit.whatsapp}
                          >
                            <i className="fal fa-layer-group" />
                          </Button>
                        </div>
                      </td>
                      <td style={{ minWidth: 400 }}>
                        <div className="d-flex align-center gap-10">
                          <div
                            className={styles.url}
                            onClick={() => {
                              setOpenSelectAddress(true);
                              setSelectedUnit(unit);
                            }}
                          >
                            <span>{generateAddressString(unit.address)}</span>
                            <If cond={!unit?.address?.address}>
                              <InfoCircleGrey />
                            </If>

                            <If cond={!!unit?.address?.address}>
                              <InfoCircleGreen />
                            </If>
                          </div>
                          <Button
                            design="default-icon-mini-2"
                            onClick={() => {
                              setOpenCopyAddress(true);
                              setSelectedUnit(unit);
                            }}
                            disabled={!unit.address?.address}
                          >
                            <i className="fal fa-layer-group" />
                          </Button>
                        </div>
                      </td>
                      <td style={{ minWidth: 300 }}>
                        <div className="d-flex align-center gap-10">
                          <Input
                            design="mini"
                            className="w-100"
                            value={unit.ifood_merchant_id}
                            onChange={(e) =>
                              handleUnitChange(
                                unit.id,
                                "ifood_merchant_id",
                                e.target.value
                              )
                            }
                          />
                          <Button
                            design="default-icon-mini-2"
                            onClick={() => {
                              setOpenCopyIfood(true);
                              setSelectedUnit(unit);
                            }}
                            disabled={!unit.ifood_merchant_id}
                          >
                            <i className="fal fa-layer-group" />
                          </Button>
                        </div>
                      </td>
                      <td>
                        <If cond={originalUnits.indexOf(unit) !== -1}>
                          Unidade já existente
                        </If>
                        <If cond={originalUnits.indexOf(unit) === -1}>
                          <div className="d-flex justify-center">
                            <Button
                              design="danger"
                              onClick={() => removeUnit(unit.id)}
                            >
                              Excluir
                            </Button>
                          </div>
                        </If>
                      </td>
                    </tr>
                  );
                }}
              />
            </tbody>
          </table>
        </div>

        <If
          cond={units.filter((u) => u.brand_id === selectedBrand).length === 0}
        >
          <div className={styles.empty}>
            <i className="fal fa-store" />
            <p className={styles.title}>
              Você ainda não possui nenhuma unidade cadastrada
            </p>
            <p className={styles.subtitle}>
              Através desta ferramenta, você pode registrar e configurar as
              unidades das suas lojas.
            </p>
            <Button design="primary" onClick={() => setUnits([emptyUnit])}>
              Adicionar unidade
            </Button>
          </div>
        </If>

        <If cond={units.length > 0}>
          <div className={styles.footer}>
            <Button onClick={() => setOpenAddMultiple(true)} className="gap-15">
              <i className="fas fa-plus" />
              Adicionar múltiplas unidades
            </Button>
            <Button
              onClick={() => setUnits([...units, emptyUnit])}
              className="gap-15"
            >
              <i className="fas fa-plus" />
              Adicionar unidade
            </Button>
            <Button onClick={save} design="primary">
              Salvar alterações
            </Button>
          </div>
        </If>
      </div>

      <Drawer
        visible={openDescription}
        onClose={() => setOpenDescription(false)}
        title="Descrição"
        subtitle={environment?.unit?.name}
      >
        <Label required>Insira a descrição desta marca:</Label>
        <Textarea
          design="three"
          placeholder="Descrição"
          value={selectedUnit?.description}
          minHeight={150}
          onChange={(e) =>
            setSelectedUnit({ ...selectedUnit, description: e.target.value })
          }
        />
        <div className={styles.componentFooter}>
          <Button
            design="primary"
            className="w-100"
            disabled={!selectedUnit?.description}
            onClick={() => {
              const newUnits = [...units];
              const index = newUnits.findIndex((b) => b.id === selectedUnit.id);
              newUnits[index].description = selectedUnit.description;
              setUnits(newUnits);
              setOpenDescription(false);
            }}
          >
            Salvar
          </Button>
        </div>
      </Drawer>

      <Drawer
        visible={openCopyDescription}
        onClose={() => setOpenCopyDescription(false)}
        title="Replicar dado / Descrição"
        subtitle={environment?.unit?.name}
      >
        <div className={styles.messageContainer}>
          <div className={styles.header}>
            <InfoCircle />

            <div className={styles.divider} />
            <p>
              Este dado configurado será replicado em todas as marcas
              selecionadas.
            </p>
          </div>
          <div className={styles.toCopy}>{selectedUnit?.description}</div>
        </div>

        <Items />

        <div className={styles.componentFooter}>
          <Button
            design="primary"
            className="w-100"
            disabled={!selectedUnit?.description}
            onClick={() => {
              const updated = updateObjectsByIds(
                units,
                selectedItems,
                "description",
                selectedUnit?.description
              );

              setUnits(updated);
              setSelectedItems([]);
              setOpenCopyDescription(false);
            }}
          >
            Salvar
          </Button>
        </div>
      </Drawer>

      <Drawer
        visible={openCopyCnpj}
        onClose={() => setOpenCopyCnpj(false)}
        title="Replicar dado / CNPJ"
        subtitle={environment?.unit?.name}
      >
        <div className={styles.messageContainer}>
          <div className={styles.header}>
            <InfoCircle />

            <div className={styles.divider} />
            <p>
              Este dado configurado será replicado em todas as marcas
              selecionadas.
            </p>
          </div>
          <div className={styles.toCopy}>{selectedUnit?.cnpj}</div>
        </div>

        <Items />

        <div className={styles.componentFooter}>
          <Button
            design="primary"
            className="w-100"
            disabled={!selectedUnit?.cnpj}
            onClick={() => {
              const updated = updateObjectsByIds(
                units,
                selectedItems,
                "cnpj",
                selectedUnit?.cnpj
              );

              setUnits(updated);
              setSelectedItems([]);
              setOpenCopyCnpj(false);
            }}
          >
            Salvar
          </Button>
        </div>
      </Drawer>

      <Drawer
        visible={openCopyEmail}
        onClose={() => setOpenCopyEmail(false)}
        title="Replicar dado / E-mail"
        subtitle={environment?.unit?.name}
      >
        <div className={styles.messageContainer}>
          <div className={styles.header}>
            <InfoCircle />

            <div className={styles.divider} />
            <p>
              Este dado configurado será replicado em todas as marcas
              selecionadas.
            </p>
          </div>
          <div className={styles.toCopy}>{selectedUnit?.email}</div>
        </div>

        <Items />

        <div className={styles.componentFooter}>
          <Button
            design="primary"
            className="w-100"
            disabled={!selectedUnit?.email}
            onClick={() => {
              const updated = updateObjectsByIds(
                units,
                selectedItems,
                "email",
                selectedUnit?.email
              );

              setUnits(updated);
              setSelectedItems([]);
              setOpenCopyEmail(false);
            }}
          >
            Salvar
          </Button>
        </div>
      </Drawer>

      <Drawer
        visible={openCopyPhone}
        onClose={() => setOpenCopyPhone(false)}
        title="Replicar dado / Telefone"
        subtitle={environment?.unit?.name}
      >
        <div className={styles.messageContainer}>
          <div className={styles.header}>
            <InfoCircle />

            <div className={styles.divider} />
            <p>
              Este dado configurado será replicado em todas as marcas
              selecionadas.
            </p>
          </div>
          <div className={styles.toCopy}>{selectedUnit?.phone}</div>
        </div>

        <Items />

        <div className={styles.componentFooter}>
          <Button
            design="primary"
            className="w-100"
            disabled={!selectedUnit?.phone}
            onClick={() => {
              const updated = updateObjectsByIds(
                units,
                selectedItems,
                "phone",
                selectedUnit?.phone
              );

              setUnits(updated);
              setSelectedItems([]);
              setOpenCopyPhone(false);
            }}
          >
            Salvar
          </Button>
        </div>
      </Drawer>

      <Drawer
        visible={openCopyWhatsapp}
        onClose={() => setOpenCopyWhatsapp(false)}
        title="Replicar dado / Whatsapp"
        subtitle={environment?.unit?.name}
      >
        <div className={styles.messageContainer}>
          <div className={styles.header}>
            <InfoCircle />

            <div className={styles.divider} />
            <p>
              Este dado configurado será replicado em todas as marcas
              selecionadas.
            </p>
          </div>
          <div className={styles.toCopy}>{selectedUnit?.whatsapp}</div>
        </div>

        <Items />

        <div className={styles.componentFooter}>
          <Button
            design="primary"
            className="w-100"
            disabled={!selectedUnit?.whatsapp}
            onClick={() => {
              const updated = updateObjectsByIds(
                units,
                selectedItems,
                "whatsapp",
                selectedUnit?.whatsapp
              );

              setUnits(updated);
              setSelectedItems([]);
              setOpenCopyWhatsapp(false);
            }}
          >
            Salvar
          </Button>
        </div>
      </Drawer>

      <Drawer
        visible={openCopyAddress}
        onClose={() => setOpenCopyAddress(false)}
        title="Replicar dado / Endereço"
        subtitle={environment?.unit?.name}
      >
        <div className={styles.messageContainer}>
          <div className={styles.header}>
            <InfoCircle />

            <div className={styles.divider} />
            <p>
              Este dado configurado será replicado em todas as marcas
              selecionadas.
            </p>
          </div>
          <div className={styles.toCopy}>
            {generateAddressString(selectedUnit?.address)}
          </div>
        </div>

        <Items />

        <div className={styles.componentFooter}>
          <Button
            design="primary"
            className="w-100"
            disabled={!selectedUnit?.address}
            onClick={() => {
              const updated = updateObjectsByIds(
                units,
                selectedItems,
                "address",
                selectedUnit?.address
              );

              setUnits(updated);
              setSelectedItems([]);
              setOpenCopyAddress(false);
            }}
          >
            Salvar
          </Button>
        </div>
      </Drawer>

      <Drawer
        visible={openCopyIfood}
        onClose={() => setOpenCopyIfood(false)}
        title="Replicar dado / Merchant ID (iFood)"
        subtitle={environment?.unit?.name}
      >
        <div className={styles.messageContainer}>
          <div className={styles.header}>
            <InfoCircle />

            <div className={styles.divider} />
            <p>
              Este dado configurado será replicado em todas as marcas
              selecionadas.
            </p>
          </div>
          <div className={styles.toCopy}>{selectedUnit?.ifood_merchant_id}</div>
        </div>

        <Items />

        <div className={styles.componentFooter}>
          <Button
            design="primary"
            className="w-100"
            disabled={!selectedUnit?.ifood_merchant_id}
            onClick={() => {
              const updated = updateObjectsByIds(
                units,
                selectedItems,
                "ifood_merchant_id",
                selectedUnit?.ifood_merchant_id
              );

              setUnits(updated);
              setSelectedItems([]);
              setOpenCopyIfood(false);
            }}
          >
            Salvar
          </Button>
        </div>
      </Drawer>

      <Drawer
        visible={openAddMultiple}
        onClose={() => setOpenAddMultiple(false)}
        title="Adicionar múltiplas unidades"
      >
        <Label>Insira quantas unidades deseja adicionar</Label>
        <Input
          value={unitsToAdd}
          onChange={(e) => setUnitsToAdd(e.target.value)}
        />

        <div className={styles.componentFooter}>
          <Button
            design="primary"
            className="w-100"
            disabled={!unitsToAdd || unitsToAdd > 100}
            onClick={() => {
              const newUnits = Array.from({ length: unitsToAdd }, () => ({
                ...emptyUnit,
                id: uuid(),
              }));

              setUnits([...units, ...newUnits]);
              setOpenAddMultiple(false);
              setUnitsToAdd("");
            }}
          >
            Adicionar
          </Button>
        </div>
      </Drawer>

      <Drawer
        visible={openSelectAddress}
        onClose={() => setOpenSelectAddress(false)}
        title="Endereço"
        subtitle={environment?.unit?.name}
      >
        <Label className="mb-0" required>
          Insira o endereço desta unidade:
        </Label>
        <SearchAddressesLocation setSelectedAddress={setAddressOptions} />

        {addressOptions && addressOptions.address && (
          <div className={styles.mapContainer}>
            <div className={styles.map}>
              <MapContainer
                style={{ width: "100%", height: "100%" }}
                center={[
                  addressOptions.geolocation.latitude,
                  addressOptions.geolocation.longitude,
                ]}
                zoom={15}
                minZoom={15}
                maxZoom={18}
                attributionControl={false}
                zoomControl={true}
                doubleClickZoom={true}
                scrollWheelZoom={true}
              >
                <TileLayer
                  url="https://mt0.google.com/vt/lyrs=m&x={x}&y={y}&z={z}&apistyle=s.e%3Ag%7Cp.c%3A%23ff242f3e%2Cs.e%3Al.t.f%7Cp.c%3A%23ff746855%2Cs.e%3Al.t.s%7Cp.c%3A%23ff242f3e%2Cs.t%3A19%7Cs.e%3Al.t.f%7Cp.c%3A%23ffd59563%2Cs.t%3A2%7Cs.e%3Al.t.f%7Cp.c%3A%23ffd59563%2Cs.t%3A40%7Cs.e%3Ag%7Cp.c%3A%23ff263c3f%2Cs.t%3A40%7Cs.e%3Al.t.f%7Cp.c%3A%23ff6b9a76%2Cs.t%3A3%7Cs.e%3Ag%7Cp.c%3A%23ff38414e%2Cs.t%3A3%7Cs.e%3Ag.s%7Cp.c%3A%23ff212a37%2Cs.t%3A3%7Cs.e%3Al.t.f%7Cp.c%3A%23ff9ca5b3%2Cs.t%3A49%7Cs.e%3Ag%7Cp.c%3A%23ff746855%2Cs.t%3A49%7Cs.e%3Ag.s%7Cp.c%3A%23ff1f2835%2Cs.t%3A49%7Cs.e%3Al.t.f%7Cp.c%3A%23fff3d19c%2Cs.t%3A4%7Cs.e%3Ag%7Cp.c%3A%23ff2f3948%2Cs.t%3A66%7Cs.e%3Al.t.f%7Cp.c%3A%23ffd59563%2Cs.t%3A6%7Cs.e%3Ag%7Cp.c%3A%23ff17263c%2Cs.t%3A6%7Cs.e%3Al.t.f%7Cp.c%3A%23ff515c6d%2Cs.t%3A6%7Cs.e%3Al.t.s%7Cp.c%3A%23ff17263c"
                  attribution=""
                />
                <DraggableMarker
                  position={[
                    addressOptions.geolocation.latitude,
                    addressOptions.geolocation.longitude,
                  ]}
                  onChangePosition={(position) => {
                    setAddressOptions({
                      ...addressOptions,
                      geolocation: {
                        ...addressOptions.geolocation,
                        latitude: position.lat,
                        longitude: position.lng,
                      },
                    });
                  }}
                />
              </MapContainer>
            </div>

            <div className={styles.componentFooter}>
              <Button
                className="w-100"
                design="primary"
                onClick={() => {
                  handleUnitChange(selectedUnit.id, "address", addressOptions);
                  setOpenSelectAddress(false);
                }}
              >
                Confirmar
              </Button>
            </div>
          </div>
        )}
      </Drawer>

      <Drawer
        visible={openSuccess}
        onClose={() => setOpenSuccess(false)}
        direction="center"
        showCloseButton={false}
      >
        <div className={styles.success}>
          <p className={styles.title}>Sucesso!</p>
          <p className={styles.subtitle}>
            Suas últimas alterações foram salvas.
          </p>
          <Button
            design="primary"
            className="w-100 mb-15"
            onClick={() => setOpenSuccess(false)}
          >
            Continuar aqui
          </Button>
          <Button className="w-100" onClick={() => navigate("/implantacao")}>
            Ir para tela inicial
          </Button>
        </div>
      </Drawer>

      <Drawer
        visible={openError}
        onClose={() => setOpenError(false)}
        direction="center"
        showCloseButton={false}
      >
        <div className={styles.success}>
          <p className={styles.title}>Erro ao salvar</p>
          <p className={styles.subtitle}>{errorMessage}</p>
          <Button className="w-100" onClick={() => setOpenError(false)}>
            Voltar
          </Button>
        </div>
      </Drawer>
    </div>
  );
}
